import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import AuthShell, { Field, SubmitButton, ErrorNote } from "@/pages/Login";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/reset-password", {
        token,
        new_password: password,
      });
      setMessage(data.message);
      setTimeout(() => navigate("/login"), 1500);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Choose a new password"
      subtitle="Enter a new password for your account."
      footer={
        <Link to="/login" className="hover:text-foreground" data-testid="reset-back-to-login">
          Back to sign in
        </Link>
      }
    >
      <form onSubmit={submit} data-testid="reset-form">
        <ErrorNote message={error} />
        {!token && (
          <div className="mb-4 px-3.5 py-2.5 rounded-md bg-destructive/10 text-destructive text-sm">
            Missing or invalid reset token. Please use the link from your email.
          </div>
        )}
        {message && (
          <div
            className="mb-4 px-3.5 py-2.5 rounded-md bg-pillar-health/20 text-foreground text-sm"
            data-testid="reset-success"
          >
            {message}
          </div>
        )}
        <Field
          label="New password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          minLength={8}
          placeholder="At least 8 characters"
          data-testid="reset-password"
        />
        <SubmitButton loading={loading} data-testid="reset-submit">
          Reset password
        </SubmitButton>
      </form>
    </AuthShell>
  );
}
